export default "__VITE_ASSET__40805e56__"